// src/redux/middleware/socketMiddleware.js
import { initializeSocket } from 'utilities/socket';
import { receiveNotification } from './slice';
import LocalStorage from 'utilities/localStorage';

const socketMiddleware = (storeAPI) => (next) => (action) => {
  if (action.type === 'socket/connect') {
    const user = LocalStorage.getItem('Trackex_user');
    const token = user?.accessToken;

    if (!token) {
      console.warn('No auth token, skipping socket connection');
      return next(action);
    }

    const socket = initializeSocket(token);
    socket.connect();

    // Setup event handlers after socket initialization
    socket.on('connect', () => {
      // console.log('Socket connected:', socket.id);
      // Send user authentication after connection
      const user = JSON.parse(localStorage.getItem('Trackex_user'));

      if (user && user?.user_details.id) {
        socket.emit('authenticate', user.user_details.id);
        // console.log(`Sent authentication for user ${user.user_details.id}`);
      } else {
        console.error('User ID not available for socket authentication');
      }
    });

    // Setup notification listener
    socket.on('notification', (data) => {
      console.log('Received notification:', data);
    });

    // Setup notifications:update listener
    socket.on('notifications:update', (data) => {
      storeAPI.dispatch(receiveNotification(data));
    });

    socket.on('disconnect', () => {
      socket.disconnect();
      console.log('Socket disconnected');
    });
  }

  return next(action);
};

export default socketMiddleware;
